import { Request } from "./HttpService";

export const TagGroupService = {
  getTagGroups() {
    return Request("vitae/tagGroup", "GET").then((data) => {
      return data;
    });
  },
  createTagGroup(tagGroup) {
    return Request("vitae/tagGroup", "POST", tagGroup).then((data) => {
      return data;
    });
  },
  updateTagGroup(tagGroup) {
    return Request("vitae/tagGroup", "PUT", tagGroup).then((data) => {
      return data;
    });
  },
  deleteTagGroup(id) {
    return Request(`vitae/tagGroup/${id}`, "DELETE").then((data) => {
      return data;
    });
  }
};
